import { useEffect, useRef } from 'react';

/**
 * Custom hook that reloads the page if the user returns to the tab
 * after being away for more than the specified duration.
 * 
 * @param reloadAfterMinutes - Number of minutes of inactivity before reload (default: 25)
 */
export const useTabVisibility = (reloadAfterMinutes: number = 25) => {
  const lastVisibleTimeRef = useRef<number>(Date.now());
  const reloadThresholdMs = reloadAfterMinutes * 60 * 1000;

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        // Tab is hidden - record the time
        lastVisibleTimeRef.current = Date.now();
      } else {
        // Tab is visible again - check if we should reload
        const timeAway = Date.now() - lastVisibleTimeRef.current;
        
        if (timeAway >= reloadThresholdMs) {
          globalThis.location.reload();
        }
      }
    };

    // Listen for visibility changes
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [reloadThresholdMs]);
};
